<div class="wrapper">
  <div class="container-fluid">
    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item"><a href="javascript: void(0);" routerLink="/management/report">Report management</a></li>
              <li class="breadcrumb-item active" *ngIf="!!id">Edit merchant</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <!-- end page title *ngIf="!id" -->
    <div class="row" *ngIf="merchants">
      <div class="col-12">
        <div class="card-box">

          <form class="form-horizontal" role="form" autocomplete="off">

            <div class="row" *ngIf="raiseWarning">
              <div class="col-md-12 form-horizontal px-3">
                <ngb-alert [dismissible]="false">
                  <strong>Warning!</strong> {{warning}}
                </ngb-alert>
              </div>
            </div>

            <div class="row" *ngIf="raiseDanger">
              <div class="col-md-12 form-horizontal px-3">
                <ngb-alert type="danger" [dismissible]="false">
                  <strong>Error!</strong> {{danger}}
                </ngb-alert>
              </div>
            </div>

            <div class="row form-horizontal">
              <div class="col-md-6 form-horizontal px-3">
                <div class="form-group row border-bottom my-3">
                  <label class="col-12 col-form-label font-weight-bold">Merchant information</label>
                </div>

                <div class="form-group row">
                  <label for="USNNumber" class="col-3 col-form-label">USN Number</label>
                  <div class="col-9">
                    <input [(ngModel)]="merchants.usnNumber" [disabled]="disabled" [ngModelOptions]="{standalone: true}" type="text" class="form-control" id="USNNumber" placeholder="USNNumber" maxlength="15">
                  </div>
                </div>
                <div class="form-group row">
                  <label for="MerchantNumber" class="col-3 col-form-label">Merchant Number</label>
                  <div class="col-9">
                    <input [(ngModel)]="merchants.merchantNumber" [disabled]="disabled" [ngModelOptions]="{standalone: true}" type="text" class="form-control" id="MerchantNumber" placeholder="Merchant Number">
                  </div>
                </div>
                <div class="form-group row">
                  <label for="Description" class="col-3 col-form-label">Description</label>
                  <div class="col-9">
                    <input [(ngModel)]="merchants.description"[disabled]="disabled" [ngModelOptions]="{standalone: true}" type="text" class="form-control" id="Description" placeholder="Description" maxlength="15">
                  </div>
                </div>
                
                <div class="form-group row">
                  <label for="MerchantGroup" class="col-3 col-form-label">Merchant group</label>
                  <div class="col-9">
                    <ng-select bindLabel="merchantGroupId" [disabled]="disabled" style="width: 100%;" [(ngModel)]="selectedMerchantGroupId" [ngModelOptions]="{standalone: true}" [clearable]="false" [searchable]="true">
                      <ng-option [value]="merchantGroup.id" *ngFor="let merchantGroup of allMerchantGroups">
                        {{merchantGroup.description}} ({{merchantGroup.merchantGroupId}})
                      </ng-option>
                    </ng-select>
                  </div>
                </div>
                                
              </div>

              <div class="col-md-6 form-horizontal px-3">
                <div class="form-group row border-bottom my-3">
                  <label class="col-md-12 col-form-label font-weight-bold">Terminals linked to USN Number: {{merchants.usnNumber}}</label>
                </div>

                <div class="form-group row my-3" *ngIf="superUser">
                  <div class="col-md-2">
                    <label for="Client" class="col-form-label">Terminal</label>&nbsp;
                  </div>
                  <div class="col-md-7">
                    <!--<ng-select bindLabel="name" style="width: 100%;" [(ngModel)]="selectedTerminal" [disabled]="disableTerminal" [ngModelOptions]="{standalone: true}" [clearable]="false" [searchable]="true">
    <ng-option [value]="terminal.id" *ngFor="let terminal of allTerminals">
      {{terminal.description}} ({{terminal.terminalNumber}})
    </ng-option>
  </ng-select>-->
                    <input [(ngModel)]="selectedTerminal" class="form-control" id="selectedTerminal" name="selectedTerminal" placeholder="Terminal Number" maxlength="8">

                  </div>
                  <div class="col-md-3">
                    <button type="button" class="btn btn-icon waves-effect waves-light btn-outline-primary mb-1 float-right" (click)="linkTerminal()"> Link terminal<i class="mdi mdi-plus"></i> </button>
                  </div>
                </div>

                <div class="form-group row">
                  <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped mb-0" style="width: 100%; ">
                    <thead>
                      <tr>
                        <th>Terminal Number</th>
                        <th>Description</th>
                        <th class="text-right" ></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let terminal of terminals">
                        <td>{{ terminal.terminalNumber }}</td>
                        <td>{{ terminal.description }} </td>
                        <td>
                          <button type="button" *ngIf="superUser" class="btn btn-icon waves-effect waves-light btn-outline-primary fa-pull-right" (click)="removeLink(terminal)">
                            <i class="mdi mdi-file-cancel-outline"></i>
                            remove
                          </button>
                        </td>
                      </tr>
                    </tbody>
                    <tbody *ngIf="terminals?.length == 0">
                      <tr>
                        <td colspan="3" class="no-data-available">No terminals available!</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
